export const admin = [
  {
    title: "site.welcome",
    route: "Home",
    icon: "HomeIcon",
  },

  {
    title: "site.edu_management",
    icon: "PackageIcon",

    children: [
      {
        title: "edu_seasons.edu_seasons",
        route: "Edu_seasons",
      },
      {
        title: "edu_courses.edu_courses",
        route: "Edu_courses",
      },
      {
        title: "edu_schemes.edu_schemes",
        route: "Edu_schemes",
      },
      {
        title: "online_session.online_session",
        route: "OnlineSession",
      },
    ],
  },

  {
    title: "edu_programs.edu_programs",
    href: "#",
    icon: "BriefcaseIcon",


    children: [
      {
        title: "edu_programs.edu_programs",
        route: "EduPrograms",
      },
      {
        title: "edu_programs.wizard",
        route: "Wizard",
      },
      {
        title: "program_lists.program_lists",
        route: "Program_lists",
        icon: "TrendingUpIcon",
      },
    ],
  },
  {
    title: "edu_programs.course_programs",
    icon: "BriefcaseIcon",


    children: [
      {
        title: "edu_programs.course_programs",
        route: "EduCoursePrograms",
      },
      {
        title: "program_lists.program_lists",
        route: "CourseProgram_lists",
        icon: "TrendingUpIcon",
      },
      {
        title: "certificates.certificates",
        icon: "AwardIcon",
        route: "CourseCertifications",
      },
      {
        title: "exams.exams",
        route: "CourseExams",
      },

      {
        title: "exams.bank_of_questions",
        route: "CardCourseQuestions",
      },
    ],
  },
  {
    title: "master.master",
    icon: "UserIcon",
    children: [
      {
        title: "master.master",
        route: "Masters",
      },
      {
        title: "master.master_type",
        route: "MasterType",
      },
      {
        title: "master.assign_teachers",
        route: "MasterTeachers",
      },
      {
        title: "master.announcements",
        route: "MasterAnnouncements",
      },
      {
        title: "master.masterStatus",
        route: "MasterStatus",
      },
      {
        title: "master.masterSemenar",
        route: "MasterSemenar",
      },
      {
        title: "master.masterDiscussion",
        route: "MasterDiscussion",
      },
      {
        title: "master.master_editor_format",
        route: "MasterEditorFormat",
      },
    ],
  },
  {
    title: "quran_programs.quran_programs",
    icon: "BookOpenIcon",
    children: [
      {
        title: "quran_programs.quran_programs",
        route: "QuranPrograms",
      },
      {
        title: "quran_programs.assign_teacher",
        route: "QuranProgramsAssignTeacher",
      },


    ],
  },
  {
    title: "site.students_management",
    icon: "UserIcon",
    children: [
      {
        title: "students.students",
        route: "Students",
      },
      {
        title: "rooms.rooms",
        route: "Rooms",
      },
      {
        title: "ac_qualifications.ac_qualifications",
        route: "Ac_qualifications",
      },
      {
        title: "badges.badges",
        route: "Badges",
      },
    ],
  },

  {
    title: "teachers.teachers",
    icon: "UserCheckIcon",

    children: [
      {
        title: "teachers.teachers",
        route: "Teachers",
      },
      {
        title: "degrees.degrees",
        route: "Degrees",
      },
    ],
  },
  {
    title: "assessments.assessments",
    route: "Assessments",
    icon: "HeadphonesIcon",
  },

  {
    title: "site.exams_management",
    icon: "Edit2Icon",

    children: [
      {
        title: "exams.exams",
        route: "Exams",
      },
      {
        title: "result.results",
        route: "Results",
      },
      {
        title: "exams.bank_of_questions",
        route: "CardQuestions",
      },
    ],
  },
  {
    title: "certificates.certificates",
    icon: "AwardIcon",
    route: "Certification",
  },

  {
    title: "polls.polls",
    route: "Polls",
    icon: "ListIcon",
  },
  {
    title: "form_data.forms_data",
    route: "Polls",
    icon: "ListIcon",
    children: [
      {
        title: "form_data.form_data",
        route: "dynamicForm",
      },

    ],
  },
  {
    title: "announcements.announcements",
    route: "Announcements",
    icon: "AlertTriangleIcon",
  },
  {
    title: "site.library",
    icon: "ArchiveIcon",

    children: [
      {
        title: "library.my-library",
        route: "Library",
      },
      {
        title: "library.categories",
        route: "Categories",
      },
      {
        title: "library.content_types",
        route: "File_settings",
      },
      {
        title: "library.tags",
        route: "Tags",
      },
      {
        title: "library.licenses",
        route: "Licenses",
      },

    ],
  },

  {
    title: "edu_programs.hr",
    icon: "SlackIcon",

    children: [
      {
        title: "attendance.attendance",
        route: "Attendance",
      },
      {
        title: "edu_programs.departments",
        route: "Departments",
      },
      {
        title: "hr.manage_salary",
        route: "Manage_salary",
      },
      {
        title: "hr.salary_list",
        route: "Salary_list",
      },

      {
        title: "hr.payroll_list",
        route: "Payroll_list",
      },
      {
        title: "hr.increase_salary",
        route: "Increments",
      },
      {
        title: "hr.bonuses",
        route: "Bonuses",
      },
      {
        title: "hr.deductions",
        route: "Deductions",
      },
      {
        title: "hr.loans",
        route: "Loans",
      },
    ],
  },
  // {
  //   title: "invoice.financial_managment",
  //   icon: "ShoppingCartIcon",

  //   children: [
  //     {
  //       title: "invoice.invoice",
  //       route: "Invoice",
  //     },
  //   ],
  // },

  {
    title: "site.reports_management",
    icon: "BarChart2Icon",

    children: [
      {
        title: "report.report",
        route: "Reports",
      },
    ],
  },
  {
    title: "site.users_management",
    icon: "UsersIcon",

    children: [
      {
        title: "users.users",
        route: "Users",
      },
      {
        title: "users.roles",
        route: "Roles",
      },
    ],
  },
  {
    title: "log.log",
    icon: "LogInIcon",

    children: [
      {
        title: "log.log",
        href: "#",
      },
    ],
  },
  {
    title: "site.content_management",
    icon: "LayoutIcon",

    children: [
      {
        title: "news.news",
        route: "News",
      },
      {
        title: "pages.pages",
        route: "Pages",
      },
      {
        title: "pages.about",
        route: "About",
      },
      {
        title: "video_galleries.video_galleries",
        route: "VideoGallery",
      },
      {
        title: "video_galleries.supervising",
        route: "Supervising",
      },
      {
        title: "sliders.sliders",
        route: "Slider",
      },
      {
        title: "menu.menu_main",
        route: { name: "Menu", params: { id: 1 } },
      },
      {
        title: "menu.menu_sub_1",
        route: { name: "Menu", params: { id: 2 } },
      }, {
        title: "menu.menu_sub_2",
        route: { name: "Menu", params: { id: 3 } },
      }, {
        title: "menu.menu_sub_3",
        route: { name: "Menu", params: { id: 4 } },
      },
      {
        title: "faqs.faqs",
        route: "Get-faqs",
      },
    ],
  },

  {
    title: "settings.settings",
    icon: "SettingsIcon",

    children: [
      {
        title: "settings.general_settings",
        href: "#",
      },
      {
        title: "countries.countries",
        route: "Countries",
      },
      {
        title: "languages.languages",
        route: "Languages",
      },

      {
        title: "settings.paypal_settings",
        href: "#",
      },
      {
        title: "settings.cache",
        href: "#",
      },

      {
        title: "settings.sms_settings",
        href: "#",
      },
      {
        title: "settings.notifications_settings",
        href: "#",
      },
    ],
  },
];


export const teacherMaster = [
  {
    title: "site.welcome",
    route: "Home",
    icon: "HomeIcon",
  },
  {
    title: "master.master",
    icon: "UserIcon",
    children: [
      {
        title: "master.master",
        route: "Masters",
      },
      {
        title: "master.master_type",
        route: "MasterType",
      },
      {
        title: "master.assign_teachers",
        route: "MasterTeachers",
      },
      {
        title: "master.announcements",
        route: "MasterAnnouncements",
      },
      {
        title: "master.masterStatus",
        route: "MasterStatus",
      },
      {
        title: "master.masterSemenar",
        route: "MasterSemenar",
      },
      {
        title: "master.masterDiscussion",
        route: "MasterDiscussion",
      },
      {
        title: "master.master_editor_format",
        route: "MasterEditorFormat",
      },
    ],
  },


]

export const teacher = [
  {
    title: "site.welcome",
    route: "Home",
    icon: "HomeIcon",
  },

  // {
  //   title: "الكونكت ",
  //   route: "Connect",
  //   icon: "MonitorIcon",

  // },
  {
    title: "quran_programs.quran_programs",
    icon: "BookOpenIcon",
    route: "MyQuranProgramTeacher",

  },
  {
    title: "نقطة البداية",
    route: "StartingPoint",
    icon: "SunriseIcon",
  },
  {
    title: "تفاصيل البرنامج",
    route: "EduProgramDetails",
    icon: "InfoIcon",
  },
  {
    title: "معدل الإنجاز التعليمي",
    route: "CompletionPercentage",
    icon: "BarChart2Icon",
  },
  {
    title: "المسار التعليمي للبرنامج",
    route: "PathEduProgram",
    icon: "TrendingUpIcon",
  },//

  {
    title: "المشاركين في البرنامج",
    route: "EduProgramUsers",
    icon: "UsersIcon",
  },
  {
    title: "أضف محاضرات",
    route: "AddEduContents",
    icon: "LayersIcon",
  },
  // //سئلة وأجوبة
  // {
  //   title: "غرفة المذاكرة الجماعية",
  //   route: "StudyRoom",
  //   icon: "FeatherIcon",
  // },
  {
    title: "online_sessions.online_sessions_archive",
    route: "OnlineSession",
    icon: "WatchIcon",
  },
  {
    title: "الأوسمة",
    route: "Badges",
    icon: "PocketIcon",
  },
  {
    title: "announcements.announcements",
    route: "Announcements",
    icon: "AlertTriangleIcon",
  },
  {
    title: "assessments.assessments",
    route: "Assessments",
    icon: "HeadphonesIcon",
  },
  {
    title: "الأحداث والفعاليات",
    route: "Events",
    icon: "CalendarIcon",
  },
  {
    title: "ساحات النقاش",
    route: "Discussions",
    icon: "TwitchIcon",
  },




  {
    title: "settings.general_settings",
    icon: "SettingsIcon",
    route: "studentSttings"


  },
]

export const student = [
  {
    title: "site.welcome",
    route: "Home",
    icon: "HomeIcon",
  },
  // {
  //   title: "الكونكت ",
  //   route: "Connect",
  //   icon: "MonitorIcon",

  // },
  {
    title: "quran_programs.quran_programs",
    icon: "BookOpenIcon",
    children: [
      {
        title: "quran_programs.quran_programs",
        route: "QuranProgramStudent",
      },
      {
        title: "quran_programs.my_quran_program",
        route: "MyQuranProgram",
      },


    ],
  },
  {
    title: "البرامج غير المشترك بها",
    route: "UnSubscribed",
    icon: "BoxIcon",
  },//
  {
    title: "نقطة البداية",
    route: "StartingPoint",
    icon: "SunriseIcon",
  },
  {
    title: "تفاصيل البرنامج",
    route: "EduProgramDetails",
    icon: "InfoIcon",
  },
  {
    title: "معدل الإنجاز التعليمي",
    route: "CompletionPercentage",
    icon: "BarChart2Icon",
  },
  {
    title: "المسار التعليمي للبرنامج",
    route: "PathEduProgram",
    icon: "TrendingUpIcon",
  },//

  {
    title: "المشاركين في البرنامج",
    route: "EduProgramUsers",
    icon: "UsersIcon",
  },
  //سئلة وأجوبة
  {
    title: "غرفة المذاكرة الجماعية",
    route: "StudyRoom",
    icon: "FeatherIcon",
  },
  {
    title: "أسئلة وأجوبة",
    route: "FAQ",
    icon: "SlackIcon",
  },
  {
    title: "online_sessions.online_sessions_archive",
    route: "OnlineSession",
    icon: "WatchIcon",
  },
  {
    title: "الأوسمة",
    route: "Badges",
    icon: "PocketIcon",
  },
  {
    title: "الشهادات",
    route: "Certifications",
    icon: "AwardIcon",
  },
  {
    title: "الأحداث والفعاليات",
    route: "Events",
    icon: "CalendarIcon",
  },
  {
    title: "ساحات النقاش",
    route: "Discussions",
    icon: "TwitchIcon",
  },

  {
    title: "settings.general_settings",
    icon: "SettingsIcon",
    route: "studentSttings"


  },
];
export const studentMaster = [

  {
    title: "master.master",
    route: "Masters",
  },
  {
    title: "master.request_new_master",
    route: "RequestNewMaster",
  },

  {
    title: "master.announcements",
    route: "MasterAnnouncements",
  },

  {
    title: "master.masterSemenar",
    route: "MasterSemenar",
  },
  {
    title: "master.masterDiscussion",
    route: "MasterDiscussion",
  },





]
